import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'petastiKentimaYpsiliMiddle';
const args = {};

export class PetastiKentimaYpsiliMiddle extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
